@if (!companyInfoLoading && !isCompanyInformationCompleted) {
  <app-validation-message
    [type]="'warning'"
    [content]="{
      title: 'ACCOUNT.COMPANY_INFO',
      message: 'ACCOUNT.COMPANY_INFO_MSG' | translate
    }"
    [buttonText]="'ACCOUNT.SUBMIT_INFORMATION'| translate"
    [showCloseIcon]="false"
    [showbutton]="true"
    (onBtnClick)="handleBtnClick($event)"
  ></app-validation-message>
}
